// extracted by mini-css-extract-plugin
export var layoutContainer = "_ao-0";
export var layoutContainerNoRounding = "_ao-6";
export var layoutContainerOpen = "_ao-5";
export var layoutContainerResizing = "_ao-1";
export var mainContent = "_ao-2";
export var resizeDivider = "_ao-3";
export var slidePanel = "_ao-4";